<template>
  <div class="template">
    <div class="top-title2">车载GPS车辆定位（入网安装单）</div>
    <div class="top-enjoy2">丰田金融专享版本</div>
    <div class="redline"></div>
    <div class="num-con">
      入网申请安装单编号：
      <span class="num">{{showDate.saleslip.pnum}}</span>
    </div>
    <div class="temInfo">
      <p>&nbsp;&nbsp;&nbsp;&nbsp;因您安装使用的鑫诚泰车辆定位管理系统向我公司投保了责任险,为您使用该定位防盗系统更加安全放心之需,现将有关注意事项及操作办法告知如下：</p>
      <p>一、责任险承保的范围：凡在中华人民共和国境内安装的鑫诚泰车辆定位管理系统的车辆（该车辆必须手续齐全，合法有效）。</p>
      <p>二、保险责任：</p>
      <p>保险期限内，被保险机动车的下列损失和费用，保险人依照本保险合同的约定负责赔偿：</p>
      <p>1、被保险机动车被盗抢、抢劫、抢夺，经出险当地具级以上公安刑侦部门立案证明，满 60 天未查明下落的全车损失；</p>
      <p>2、被保险机动车全车被盗抢、抢劫、抢夺后，受到损坏或车上零部件、附属设备丢失需要修复的合理费用；</p>
      <p>3、被保险机动车在被抢劫、抢夺过程中，受到损坏需要修复的合理费用。</p>
      <p>三、除外责任：</p>
      <p>1、非全车遭受盗抢，仅车上零配件或附属设备被盗抢、被损坏；</p>
      <p>2、被他人诈骗造成全车或部分损失;</p>
      <p>3、车主因违反政府有关法律、法规，车辆被有关国家机关罚没、扣押；</p>
      <p>4、车主因与他人的民事、经济纠纷而被劫持、抢夺；</p>
      <p>5、租赁车辆与承租人同时失踪；</p>
      <p>6、车主的故意行为；</p>
      <p>7、客户违反本产品中规定的操作规程或擅自拆卸等引起的损失。</p>
      <p>四、有关义务：</p>
      <p>1 、全车被盗抢后，应 24 小时内向当地公安部门报案，并通过运营商在 48 小时内通过 4006601517 报案电话向我司报案。</p>
      <p>2 、车辆被盗抢后应当通过运营商向我公司索赔。索赔时，必须提供责任险细则，购车原始发票，车辆附加费发票以及具以上公安刑侦部门出具的盗抢案件立案证明和车辆已报停的手续等保险公司要求的相关理赔资料。</p>
      <p>五、赔偿处理：</p>
      <p>1 、出险车辆未购买盗抢险的，按被盗车辆实际价值的 100 ％进行赔偿；</p>
      <p>2 、我公司确认索赔单证齐全有效后 20 个工作日内支付赔款。获取赔款后，运营商及车主应协助我司责任者进行追偿。</p>
      <p>特别声明：若投保车辆是车主使用<span class="underline">{{showDate.saleslip.firstbeneficiaryname}}</span>贷款所购，未还清<span class="underline">{{showDate.saleslip.firstbeneficiaryname}}</span>贷款之前，同意<span class="underline">{{showDate.saleslip.firstbeneficiaryname}}</span>为第一受益人。</p>
      <div class="custom">
        客户签名：
        <div class="companyinfo">
          <p>中国人寿财产保险股份有限公司青岛市分公司</p>
          <p>{{$formatTimeCN2(showDate.saleslip.pstarttime)}}</p>
        </div>
      </div>
    </div>
    <table class="personal-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td width="130">客户姓名</td>
        <td colspan="2">{{showDate.saleslip.customername}}</td>
        <td width="130">证件号码</td>
        <td colspan="2">{{showDate.saleslip.certificatenum}}</td>
      </tr>
      <tr>
        <td>联系地址</td>
        <td colspan="5">{{showDate.saleslip.address}}</td>
      </tr>
      <tr>
        <td>联系电话</td>
        <td colspan="2">{{showDate.saleslip.phone}}</td>
        <td>车牌号码</td>
        <td colspan="2">{{showDate.saleslip.carnum}}</td>
      </tr>
      <tr>
        <td width="130">车架号</td>
        <td colspan="2">{{showDate.saleslip.frame}}</td>
        <td>发动机号</td>
        <td colspan="2">{{showDate.saleslip.enginenum}}</td>
      </tr>
      <tr>
        <td>设备功能</td>
        <td colspan="5">全球定位 实时定位 轨迹回放</td>
      </tr>
      <!-- <tr>
        <td>保险期限</td>
        <td
          colspan="5"
        >自{{$formatTimeCN2(showDate.saleslip.pstarttime)}}00时起至{{getendTime($formatTimeCN2(showDate.saleslip.pstarttime))}}24时止</td>
      </tr> -->
    </table>
    <div class="temInfo">
      <div class="custom">
        <div class="companyinfo">
          <p>青岛鑫诚泰网络科技有限公司</p>
          <p>{{$formatTimeCN2(showDate.saleslip.pstarttime)}}</p>
        </div>
      </div>
    </div>
    <img class="mdinis" src="@/assets/images/inis.png" alt="">
    <img class="mdinis2-2" src="@/assets/images/inis2-2.png" alt="">
  </div>
</template>

<script>
export default {
  props: ["showDate", "selectYear"],
  data() {
    return {};
  },
  mounted() {
    // this.ini ()
  },
  methods: {
    getendTime(str) {
      str = str.split("年");
      let tempdata = Number(str[0]);
      str[0] = tempdata += this.selectYear;
      return str.join("年");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/template/md2.vue